<template>
  <div>
    <div class="photo-album">
      <div class="album-img" ref="listContainer"  v-show="!albumtab">
        <div  class="list-container">
          <div  class="group-items">
            <div v-for="(img,index) in info.pic" :key="index">
              <img v-lazy="ImgPreUrl+img" height="14px" class="meeting-img gallery-img" @click="carouse(index)"/>
            </div>
          </div>
        </div>
      </div>
      <Carousels :info="info.pic" v-if="albumtab" :indexist="indexist" @albumtab="albumtab=false"></Carousels>  
      <!--相册导航-->
      <div class="album-name">
        <div class="rooms-title">
            {{ info.title }}
            <span v-if="info.assist">({{ info.assist }})</span>
        </div>
        <div class="star-content">
            <div>房间总数：{{ info.num}} 间</div>
        </div>
        <div class="star-content">
            <div>房间面积：{{ info.area }}m²</div>
        </div>
        <div class="star-content">
            <div>房间类型：{{ info.type  | formatVar('brandroomStyle')}}</div>
        </div>
        <div class="star-content">
            <div>房间规格：{{info.specs }}</div>
        </div>
        <div class="star-content">
            <div>房间窗户：{{ info.window  | formatVar('windowStyle') || '/'}}</div>
        </div>
        <div class="star-feature" v-for="item in feature" :key="item.key">
            <div class="rooms-feature" v-if="info[item.key].length>0">
                {{ item.name }}
            </div>
            <div class="star-name"> 
                <div v-for="(value,index) in info[item.key]" :key="index" >
                    <i class="el-icon-circle-check"></i>
                    {{value}}
                </div>
            </div>
        </div>
        <div class="bottom"></div>
        <!-- <div class="Introduction-btn" @click="$emit('bookHotel')">
            去询价
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Carousels from "./Comps/Carousels.vue";
export default {
  name: 'photoAlbum',
  components: {Carousels},
  props: {
    info: {
        type: Object,
        default: () => ({})
    },
  },
  data() {
    return {
        feature:[
            {name:'房间用品',key:'RoomAmenities'},
            {name:'房间设施',key:'RoomFacility'},
            {name:'房间设备',key:'RoomEquipment'},
            {name:'房间特色',key:'Roomeature'},
        ],
        albumtab:false,
    };
  },
  computed: {},
  watch: {
    info: {
        handler(newVal, oldVal) {
            this.init();

        },
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //点击放大图片
    carouse(index){
       this.albumtab=true;
       this.indexist=index;
    },
    // 初始化图片
    init(){
        const info = this.info;
        info.feature=this.$verify.stitch(info.feature);
        info.RoomAmenities=this.$verify.formatVar(info.feature,'RoomAmenities');
        info.RoomFacility=this.$verify.formatVar(info.feature,'RoomFacility');
        info.RoomEquipment=this.$verify.formatVar(info.feature,'RoomEquipment');
        info.Roomeature=this.$verify.formatVar(info.feature,'Roomeature');
    }
  }
};
</script>

<style lang="scss" scoped>
.photo-album-title{
  text-align: left;
}
.photo-album{
    width: 100%;
    display: flex;
    border-top: 1px #eee solid;
    padding-top: 10px;
}
.album-img{
    width: 76%;
    padding: 0 2%;
    height: 800px;
    overflow: auto;
}
.album-name{
    width: 18%;

    position: relative;
    border-left: 1px #eee solid;
    padding: 0 1%;
}
.group-title {
  font-size: 18px;
  color: #666;
  padding: 10px 0;
  font-weight: bold;
  text-align: left;
}
.group-items{
  width: 100%;
  display: flex;
  flex-wrap:wrap;
  div{
    width: calc(50% - 12px);
    margin-bottom: 12px;
    margin-right: 12px;
    height: 500px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.active{
  background-color: var(--smtc-color-primary);
  color: #fff;
}
.rooms-title{
    text-align: left;
    font-weight: bold;
    font-size: 24px;
    color: #333;
}
.star-content{
    text-align: left;
    display: flex;
    color: #333;
    margin-top: 6px;
    div{
        margin-right: 20px;
        min-width: 60px;
        line-height: 24px;
        display: flex;
    }
    .tel{
        span{
            display: block;
        }
    }
}
.rooms-feature{
    display: flex;
    font-weight: bold;
    font-size: 16px;
    color: #333;
    text-align: left;
    margin-top: 16px;
}
.star-name{
    display: flex;
    flex-wrap: wrap;
    >div{
        width: 50%;
        text-align: left;
        margin-top: 16px;
        display: flex; 
        i{
            font-size: 16px;
            margin-top: 3px;
            margin-right: 6px;
        }
    }
}
.bottom{
    overflow: hidden;
    height: 80px;
    width: 10px;    
}
.Introduction-btn{
  width: 100px;
  height: 60px;
  line-height: 60px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  background-color: var(--smtc-color-primary);
  color: #fff;
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.gallery-img{
    cursor: pointer;
}
</style>
